module.exports = __webpack_public_path__ + "img/logo.1d6240b0.png";